<template>
  <!-- 支持远程搜索、向下滚动分页加载 -->
  <div>
    <el-select v-model="formParam[fieldName]" placeholder="请输入后选择" filterable remote reserve-keyword
               :multiple="multiple" clearable :disabled="disabled" :remote-method="queryCustomerList" :loading="loading"
               style="width:100%;" v-loadMore="loadMoreCustomerList" @clear="initList" @blur="blurMethod" @change="changeMethod">
      <el-option v-for="item in customerList" :key="item.id" :label="item.customerName" :value="item.id"/>
    </el-select>
  </div>
</template>

<script>
import {listSimplePage, listSimplePageWithAuth} from "@/api/crm/customer";
import {mapState} from "vuex";

export default {
  name: "customerSelect",
  props: {
    formParam: {},
    paramList: {
      type: Array,
      default() {
        return []
      }
    },
    authCheck: { // 是否需要控制数据权限
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fieldName: {
      type: String,
      default: 'customerId'
    },
  },
  data () {
    return {
      customerList: [],
      loading: false,
      searchValue: null,
      pageNum: 1,
      pageSize: 30,
      hasNextPage: true
    };
  },
  components: {},
  mounted () {
    this.pageNum = 1
    if (this.paramList && this.paramList.length > 0) {
      this.customerList = this.paramList
      setTimeout(() => {
        this.initList()
      }, 800);
    } else {
      this.initList()
    }
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId,
    })
  },
  watch: {},
  methods: {
    queryCustomerList (searchValue) {
      this.searchValue = searchValue
      if (searchValue) {
        setTimeout(() => {
          this.loading = true;
          this.query({pageNum: 1, pageSize: this.pageSize, searchValue: searchValue})
        }, 400);
      } else {
        // 这个地方置空是为了减少由于滚动条太长，导致一下子加载很多页的情况
        this.customerList = []
        this.query({pageNum: 1, pageSize: this.pageSize})
      }
    },
    initList () {
      this.searchValue = null
      this.customerList = []
      this.query({pageNum: 1, pageSize: this.pageSize})
    },
    query (param) {
      if (this.authCheck) {
        listSimplePageWithAuth(param).then(response => {
          this.customerList = response.data.list
          this.hasNextPage = response.data.hasNextPage
          this.pageNum = response.data.nextPage
        }).finally(() => {
          this.loading = false;
        });
      } else {
        listSimplePage(param).then(response => {
          this.customerList = response.data.list
          this.hasNextPage = response.data.hasNextPage
          this.pageNum = response.data.nextPage
        }).finally(() => {
          this.loading = false;
        });
      }
    },
    loadMoreCustomerList () {
      if (!this.hasNextPage) {
        return
      }
      let param = {pageNum: this.pageNum, pageSize: this.pageSize, searchValue: this.searchValue}
      if (this.authCheck) {
        listSimplePageWithAuth(param).then(response => {
          let resList = response.data.list
          if (resList && resList.length > 0) {
            this.customerList = this.customerList.concat(resList)
          }
          this.hasNextPage = response.data.hasNextPage
          this.pageNum = response.data.nextPage
        })
      } else {
        listSimplePage(param).then(response => {
          let resList = response.data.list
          if (resList && resList.length > 0) {
            this.customerList = this.customerList.concat(resList)
          }
          this.hasNextPage = response.data.hasNextPage
          this.pageNum = response.data.nextPage
        })
      }
    },
    changeMethod (data) {
      this.$emit('change', data)
    },
    blurMethod (event) {
      setTimeout(() => {
        this.initList()
      }, 300);
    }
  }
};
</script>
